"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GA4FeatureCategory = void 0;
var GA4FeatureCategory;
(function (GA4FeatureCategory) {
    GA4FeatureCategory["Cart"] = "cart";
    GA4FeatureCategory["ProductDetailInformation"] = "Productdetail information";
    GA4FeatureCategory["ProductdetailBuybox"] = "Productdetail buybox";
    GA4FeatureCategory["ProductdetailGallery"] = "Productdetail gallery";
    GA4FeatureCategory["CustomerAccount"] = "Customer Account";
    GA4FeatureCategory["CustomerAccountSignUp"] = "Customer Account Sign Up";
    GA4FeatureCategory["ProductList"] = "Productlist";
    GA4FeatureCategory["PromotionDynamic"] = "Promotion_dynamic";
    GA4FeatureCategory["PromotionStatic"] = "Promotion_static";
    GA4FeatureCategory["Search"] = "search";
    GA4FeatureCategory["Ecommerce"] = "ecommerce";
    GA4FeatureCategory["Filter"] = "Filter";
    GA4FeatureCategory["ProductdetailBoxList"] = "Productdetail box product list";
    GA4FeatureCategory["HeaderNavigation"] = "Header navigation";
    GA4FeatureCategory["DirectBooking"] = "Direct booking";
    GA4FeatureCategory["ProviderList"] = "Provider List";
    GA4FeatureCategory["SideNavigation"] = "side navigation";
    GA4FeatureCategory["TopNavigation"] = "top navigation";
    GA4FeatureCategory["BurgerNavigation"] = "burger navigation";
    GA4FeatureCategory["BreadcrumbNavigation"] = "breadcrumb navigation";
    GA4FeatureCategory["PageSliderNavigation"] = "page slider navigation";
    GA4FeatureCategory["FooterNavigation"] = "Footer navigation";
    GA4FeatureCategory["Newsletter"] = "newsletter";
    GA4FeatureCategory["Wishlist"] = "Wishlist";
    GA4FeatureCategory["ProductDetailClusterProductList"] = "Productdetail cluster product list";
})(GA4FeatureCategory || (exports.GA4FeatureCategory = GA4FeatureCategory = {}));
//# sourceMappingURL=GA4FeatureCategory.js.map